import React from "react";

import Card from "~/account/Integrations/Card";
import { ReactComponent as HubspotLogo } from "~/legacy-assets/images/logos/hubspot.svg";

import { getTooltipContent } from "./utils";

import type { UserIntegrationsQuery$data as UserIntegrationQueryType } from "~/__generated__/UserIntegrationsQuery.graphql";

import styles from "./Hubspot.module.css";

interface HubspotProps {
	viewer: UserIntegrationQueryType["viewer"];
	className?: string;
	connection: {
		id?: string;
		email?: string;
		isConnected?: boolean; // Legacy
	} | null;
}

export function HubspotUserCard(props: HubspotProps) {
	// We can still have users connected to this integration with the old style.
	//  Only show the notice text for users not connected.
	const legacyConnected = props.connection?.isConnected ?? false;
	const userConnected = props.viewer.account?.integrations.hubspot?.userConnected ?? false;
	const accountConnected = props.viewer.account?.integrations.hubspot?.accountConnected ?? false;
	const userCanHubspot = legacyConnected || (userConnected && accountConnected);
	const isAdmin = props.viewer.user.internalAttributes?.isAccountAdmin ?? false;
	const primaryAdminFullName = props.viewer.account?.primaryAdmin?.fullName ?? "";
	const otherCRMConnected = !!props.viewer.integrations.salesforce?.isConnected;

	const noticeText = getTooltipContent(
		otherCRMConnected,
		accountConnected,
		legacyConnected,
		isAdmin,
		primaryAdminFullName,
	);

	/* There are 5 cases
		1: User is on legacy user level integration, keep things as it was before.
		2: User is an admin and does not have the integration connected
		3: User is an admin and has the integration connected
		3b: Also has enabled the integration on their account
		3c: User has disabled the integration on their account
		4: User is a member and the admin has not connected the integration
		5: User is a member and the admin has connected the integration
		5a: Also has enabled the integration on their account
		5b: User has disabled the integration on their account
	*/

	return (
		<Card
			name="HubSpot"
			description="Sync your notes to HubSpot and view key HubSpot data within Fellow."
			logo={<HubspotLogo style={{ width: "auto", height: "24px" }} />}
			className={props.className}
			connected={userCanHubspot}
			showConnectedLabel={userCanHubspot}
			noticeText={noticeText}
		>
			{legacyConnected && (
				<div className={styles.cardContent}>
					{props.connection?.email && (
						<span>
							Connected as <a>{props.connection.email}</a>
						</span>
					)}
				</div>
			)}
		</Card>
	);
}
